import { Stripe, loadStripe } from "@stripe/stripe-js"

export const stripeKey =
  process.env.NEXT_PUBLIC_STRIPE_KEY ||
  process.env.NEXT_PUBLIC_MEDUSA_PAYMENTS_PUBLISHABLE_KEY

const medusaAccountId = process.env.NEXT_PUBLIC_MEDUSA_PAYMENTS_ACCOUNT_ID

let cachedPromise: Promise<Stripe | null> | null = null

/**
 * Module-level singleton so Stripe.js is only loaded once per page no matter
 * how many components need it (checkout Elements, financing messaging, etc.).
 * Returns null when no publishable key is configured.
 */
export const getStripePromise = (): Promise<Stripe | null> | null => {
  if (!stripeKey) {
    return null
  }

  if (!cachedPromise) {
    cachedPromise = loadStripe(
      stripeKey,
      medusaAccountId ? { stripeAccount: medusaAccountId } : undefined
    )
  }

  return cachedPromise
}
